import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import GgmsSidebarAndHeader from "@/components/GgmsSidebarAndHeader.vue"
import GgmsToasts from "@/components/GgmsToasts.vue"
import { useAgencyStore } from "@/stores/agency"
import { useAgencyThemeStore } from "@/stores/agency-theme"
import { setColorShades } from "@/shared/utils/color-helpers"
import { ToastService } from "@/shared/services/toast"


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const agencyStore = useAgencyStore()
const agencyThemeStore = useAgencyThemeStore()
const toastService = new ToastService()

const selectedAgencyAndDomain = computed(() => agencyStore.selectedAgencyAndDomain)

const storedPrimaryColor = localStorage.getItem("--primary-color")
const storedLinkColor = localStorage.getItem("--link-color")

if (storedPrimaryColor && storedPrimaryColor !== "{}") {
    setColorShades("--primary-color", storedPrimaryColor)
}

if (storedLinkColor && storedLinkColor !== "{}") {
    setColorShades("--link-color", storedLinkColor)
}

function handleRedirectErrorMessage() {
    const redirectErrorMessage = route.query as { errorMessage?: string }

    if (!redirectErrorMessage?.errorMessage) {
        return
    }
    toastService.addToast({
        type: "error",
        message: redirectErrorMessage?.errorMessage,
    })

    // After showing the error message, remove it from the url
    router.replace({ query: {} })
}

onMounted(async () => {
    await agencyThemeStore.getAgencyThemeBySubdomain()
    handleRedirectErrorMessage()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GgmsToasts),
    (_unref(route)?.meta?.requiresAuth)
      ? (_openBlock(), _createBlock(GgmsSidebarAndHeader, { key: 0 }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_router_view, { key: selectedAgencyAndDomain.value }))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
  ], 64))
}
}

})